(function () {
  'use strict';

  // ── Configuration ──────────────────────────────────────────────────────────

  var CONFIG = {
    COOKIE_EXPIRY_DAYS: 365,
    COOKIE_PREFIX: 'table-columns-'
  };

  var ATTRIBUTES = {
    TABLE_KEY: 'data-table-toggle-view',
    VIEW_OPTIONS_KEY: 'data-table-view-options',
    COL_INDEX: 'data-col-idx',
    TH_LABEL: 'data-th-label'
  };

  var SELECTORS = {
    TABLE: '[data-table-toggle-view]',
    VIEW_OPTIONS: '[data-table-view-options]',
    PANEL: '[data-table-toggle-view-panel]',
    TOGGLE_BUTTON: '[data-table-toggle-panel]',
    COLUMN_TOGGLES: '[data-column-toggles]',
    VISIBLE_SELECT: '[data-visible-select]',
    HIDDEN_SELECT: '[data-hidden-select]',
    MOVE_UP: '[data-move-up]',
    MOVE_DOWN: '[data-move-down]'
  };

  var CSS_CLASSES = {
    HIDDEN_COLUMN: 'c-table-wrapper__column--hidden',
    PANEL_HIDDEN: 'c-tableview-options__panel--hidden'
  };

  // ── Helpers ────────────────────────────────────────────────────────────────

  function getColumnLabel(th) {
    return th.getAttribute(ATTRIBUTES.TH_LABEL) || '';
  }

  // ── Storage Abstraction ────────────────────────────────────────────────────

  var storage = {
    save: function (key, data) {
      var name = CONFIG.COOKIE_PREFIX + key;
      var value = JSON.stringify(data);
      var expires = '';
      var date = new Date();
      date.setTime(date.getTime() + (CONFIG.COOKIE_EXPIRY_DAYS * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toUTCString();
      document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/';
    },

    load: function (key) {
      var name = CONFIG.COOKIE_PREFIX + key;
      var nameEQ = name + '=';
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) {
          var value = decodeURIComponent(c.substring(nameEQ.length, c.length));
          try {
            return JSON.parse(value);
          } catch (e) {
            return null;
          }
        }
      }
      return null;
    }
  };

  // ── Column Settings ────────────────────────────────────────────────────────

  function saveColumnSettings(key, columns) {
    var settings = columns.map(function (col) {
      return {
        originalIndex: col.originalIndex,
        label: col.label,
        visible: col.visible
      };
    });
    storage.save(key, settings);
  }

  function loadColumnSettings(key) {
    return storage.load(key);
  }

  /**
   * Tags every untagged <td> in tbody rows with data-col-idx matching its
   * current DOM position. Must be called while cells are still in original
   * template order (i.e. on init or right after XHR replaces tbody content).
   */
  function tagUntaggedRows(table) {
    table.querySelectorAll('tbody tr').forEach(function (row) {
      Array.from(row.children).forEach(function (td, i) {
        if (!td.hasAttribute(ATTRIBUTES.COL_INDEX)) {
          td.setAttribute(ATTRIBUTES.COL_INDEX, i);
        }
      });
    });
  }

  // ── Table rendering ────────────────────────────────────────────────────────

  /**
   * Reorders and shows/hides columns in the DOM according to instance.columns.
   * instance.columns is the single source of truth for order and visibility.
   */
  function applyColumnsToTable(instance) {
    var table = instance.table;
    var columns = instance.columns;

    tagUntaggedRows(table);

    // thead – append each th in columns order (appendChild moves existing nodes)
    var headRow = table.querySelector('thead tr');
    if (headRow) {
      columns.forEach(function (col) {
        headRow.appendChild(col.headerCell);
        col.headerCell.classList.toggle(CSS_CLASSES.HIDDEN_COLUMN, !col.visible);
      });
    }

    // tbody – same approach per row, locate cell by data-col-idx
    table.querySelectorAll('tbody tr').forEach(function (row) {
      columns.forEach(function (col) {
        var td = row.querySelector('[' + ATTRIBUTES.COL_INDEX + '="' + col.originalIndex + '"]');
        if (td) {
          row.appendChild(td);
          td.classList.toggle(CSS_CLASSES.HIDDEN_COLUMN, !col.visible);
        }
      });
    });
  }

  // ── Dual-select state ──────────────────────────────────────────────────────

  function syncSelectsFromColumns(instance) {
    var visibleSelect = instance.visibleSelect;
    var hiddenSelect = instance.hiddenSelect;

    var prevVisible = visibleSelect.value;
    var prevHidden = hiddenSelect.value;

    visibleSelect.innerHTML = '';
    hiddenSelect.innerHTML = '';

    instance.columns.forEach(function (col) {
      if (!col.label) return; // skip unlabelled action columns
      if (col.locked) return; // skip locked columns
      var option = document.createElement('option');
      option.value = col.originalIndex;
      option.textContent = col.label;
      (col.visible ? visibleSelect : hiddenSelect).appendChild(option);
    });

    // Restore previous selection where possible
    visibleSelect.value = prevVisible;
    hiddenSelect.value = prevHidden;

    updateButtonStates(instance);
  }

  function updateButtonStates(instance) {
    var select = instance.visibleSelect;
    var idx = select.selectedIndex;
    var count = select.options.length;
    instance.btnUp.disabled = idx <= 0;
    instance.btnDown.disabled = idx < 0 || idx >= count - 1;
  }

  // ── Column operations ──────────────────────────────────────────────────────

  function moveToHidden(instance) {
    var origIdx = parseInt(instance.visibleSelect.value, 10);
    if (isNaN(origIdx)) return;

    var col = instance.columns.find(function (c) { return c.originalIndex === origIdx; });
    if (!col || col.locked) return; // Prevent hiding locked columns
    col.visible = false;

    applyColumnsToTable(instance);
    syncSelectsFromColumns(instance);
    instance.hiddenSelect.value = origIdx;
    saveColumnSettings(instance.key, instance.columns);
  }

  function moveToVisible(instance) {
    var origIdx = parseInt(instance.hiddenSelect.value, 10);
    if (isNaN(origIdx)) return;

    var col = instance.columns.find(function (c) { return c.originalIndex === origIdx; });
    if (!col) return;
    col.visible = true;

    applyColumnsToTable(instance);
    syncSelectsFromColumns(instance);
    instance.visibleSelect.value = origIdx;
    updateButtonStates(instance);
    saveColumnSettings(instance.key, instance.columns);
  }

  function moveUp(instance) {
    var origIdx = parseInt(instance.visibleSelect.value, 10);
    if (isNaN(origIdx)) return;

    var visibleCols = instance.columns.filter(function (c) { return c.visible && c.label; });
    var pos = visibleCols.findIndex(function (c) { return c.originalIndex === origIdx; });
    if (pos <= 0) return;

    // Prevent moving past locked columns
    if (visibleCols[pos - 1].locked) return;

    var idxA = instance.columns.indexOf(visibleCols[pos]);
    var idxB = instance.columns.indexOf(visibleCols[pos - 1]);
    var tmp = instance.columns[idxA];
    instance.columns[idxA] = instance.columns[idxB];
    instance.columns[idxB] = tmp;

    applyColumnsToTable(instance);
    syncSelectsFromColumns(instance);
    instance.visibleSelect.value = origIdx;
    updateButtonStates(instance);
    saveColumnSettings(instance.key, instance.columns);
  }

  function moveDown(instance) {
    var origIdx = parseInt(instance.visibleSelect.value, 10);
    if (isNaN(origIdx)) return;

    var visibleCols = instance.columns.filter(function (c) { return c.visible && c.label; });
    var pos = visibleCols.findIndex(function (c) { return c.originalIndex === origIdx; });
    if (pos < 0 || pos >= visibleCols.length - 1) return;

    var idxA = instance.columns.indexOf(visibleCols[pos]);
    var idxB = instance.columns.indexOf(visibleCols[pos + 1]);
    var tmp = instance.columns[idxA];
    instance.columns[idxA] = instance.columns[idxB];
    instance.columns[idxB] = tmp;

    applyColumnsToTable(instance);
    syncSelectsFromColumns(instance);
    instance.visibleSelect.value = origIdx;
    updateButtonStates(instance);
    saveColumnSettings(instance.key, instance.columns);
  }

  // ── UI construction ────────────────────────────────────────────────────────

  function buildDualSelectUI(instance) {
    var panel = instance.panel;
    var container = panel.querySelector(SELECTORS.COLUMN_TOGGLES);
    if (!container) return;

    instance.visibleSelect = container.querySelector(SELECTORS.VISIBLE_SELECT);
    instance.hiddenSelect = container.querySelector(SELECTORS.HIDDEN_SELECT);
    instance.btnUp = container.querySelector(SELECTORS.MOVE_UP);
    instance.btnDown = container.querySelector(SELECTORS.MOVE_DOWN);

    instance.visibleSelect.addEventListener('change', function () {
      updateButtonStates(instance);
    });

    instance.visibleSelect.addEventListener('dblclick', function () {
      moveToHidden(instance);
    });

    instance.hiddenSelect.addEventListener('dblclick', function () {
      moveToVisible(instance);
    });

    instance.btnUp.addEventListener('click', function () {
      moveUp(instance);
    });

    instance.btnDown.addEventListener('click', function () {
      moveDown(instance);
    });
  }

  // ── Init ───────────────────────────────────────────────────────────────────

  /**
   * Initialize event listener for the rowsPerPage select element.
   * When the user changes the value, the form is submitted automatically.
   */
  function initRowsPerPageListener() {
    var rowsPerPageSelect = document.getElementById('rowsPerPage');
    if (!rowsPerPageSelect) return;

    // Avoid duplicate event listeners
    if (rowsPerPageSelect.dataset.listenerInitialized) return;

    rowsPerPageSelect.addEventListener('change', function () {
      var form = this.closest('form');
      if (form) {
        var submitEvent = new Event('submit', { bubbles: true, cancelable: true });
        form.dispatchEvent(submitEvent);
      }
    });

    rowsPerPageSelect.dataset.listenerInitialized = 'true';
  }

  /**
   * Initialize toggle button event listeners for all view options.
   * This is called once on page load to avoid duplicate event listeners.
   */
  function initToggleButtons() {
    document.querySelectorAll(SELECTORS.VIEW_OPTIONS).forEach(function (viewOptions) {
      if (viewOptions.dataset.toggleButtonInitialized) return;

      var panel = viewOptions.querySelector(SELECTORS.PANEL);
      var toggleButton = viewOptions.querySelector(SELECTORS.TOGGLE_BUTTON);

      if (!panel || !toggleButton) return;

      var key = viewOptions.getAttribute(ATTRIBUTES.VIEW_OPTIONS_KEY);
      if (!key) return;

      toggleButton.addEventListener('click', function () {
        var isOpening = panel.classList.contains(CSS_CLASSES.PANEL_HIDDEN);
        panel.classList.toggle(CSS_CLASSES.PANEL_HIDDEN);

        if (isOpening) {
          // Sync selects when opening the panel
          if (viewOptions._tableToggleInstance) {
            syncSelectsFromColumns(viewOptions._tableToggleInstance);
          }
        }
      });

      viewOptions.dataset.toggleButtonInitialized = 'true';
    });
  }

  function initTableToggleViewColumn() {
    initToggleButtons();
    initRowsPerPageListener();

    document.querySelectorAll(SELECTORS.TABLE).forEach(function (table) {
      var key = table.getAttribute(ATTRIBUTES.TABLE_KEY);
      if (!key) return;

      var viewOptions = document.querySelector('[' + ATTRIBUTES.VIEW_OPTIONS_KEY + '="' + key + '"]');
      if (!viewOptions) return;

      var panel = viewOptions.querySelector(SELECTORS.PANEL);
      if (!panel) return;

      // Check if we already have an instance stored on viewOptions (after XHR reload)
      if (viewOptions._tableToggleInstance) {
        // Table was reloaded via XHR - update references
        var instance = viewOptions._tableToggleInstance;

        // Update table reference to point to new DOM element
        instance.table = table;

        // Update headerCell references to point to new DOM elements
        var newHeaders = table.querySelectorAll('thead th');
        instance.columns.forEach(function (col) {
          if (newHeaders[col.originalIndex]) {
            col.headerCell = newHeaders[col.originalIndex];
          }
        });

        // Re-tag rows and reapply column order to the new table
        tagUntaggedRows(table);
        applyColumnsToTable(instance);

        return; // Skip re-initialization of event listeners
      }

      // First-time initialization
      var columns = [];
      table.querySelectorAll('thead th').forEach(function (th, index) {
        columns.push({
          originalIndex: index,
          label: getColumnLabel(th),
          visible: true,
          locked: index === 0, // First column is locked
          headerCell: th
        });
      });

      tagUntaggedRows(table);

      var instance = {
        table: table,
        panel: panel,
        columns: columns,
        key: key,
        visibleSelect: null,
        hiddenSelect: null,
        btnUp: null,
        btnDown: null
      };

      // Load saved settings from cookie
      var savedSettings = loadColumnSettings(key);
      if (savedSettings) {
        // Create a map of saved settings by originalIndex
        var settingsMap = {};
        savedSettings.forEach(function (setting) {
          settingsMap[setting.originalIndex] = setting;
        });

        // Apply saved visibility (but keep locked columns always visible)
        instance.columns.forEach(function (col) {
          if (col.locked) {
            col.visible = true; // Locked columns always visible
            return;
          }
          var saved = settingsMap[col.originalIndex];
          if (saved) {
            col.visible = saved.visible;
          }
        });

        // Restore saved column order (but keep locked columns at the start)
        instance.columns.sort(function (a, b) {
          // Locked columns always come first in their original order
          if (a.locked && b.locked) return a.originalIndex - b.originalIndex;
          if (a.locked) return -1;
          if (b.locked) return 1;

          var indexA = savedSettings.findIndex(function (s) { return s.originalIndex === a.originalIndex; });
          var indexB = savedSettings.findIndex(function (s) { return s.originalIndex === b.originalIndex; });

          // If not found in saved settings, keep at end
          if (indexA === -1) indexA = 999;
          if (indexB === -1) indexB = 999;

          return indexA - indexB;
        });
      }

      buildDualSelectUI(instance);
      applyColumnsToTable(instance);
      syncSelectsFromColumns(instance);

      // Store instance on viewOptions (not on table) so it persists across XHR reloads
      viewOptions._tableToggleInstance = instance;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTableToggleViewColumn);
  } else {
    initTableToggleViewColumn();
  }

  // Re-init after XHR inserts new table instances
  window.initTableToggleViewColumn = initTableToggleViewColumn;

  // Call after XHR replaces tbody content to re-tag new rows and reapply column order
  window.reapplyTableOrder = function (key) {
    var viewOptions = document.querySelector('[' + ATTRIBUTES.VIEW_OPTIONS_KEY + '="' + key + '"]');
    if (viewOptions && viewOptions._tableToggleInstance) {
      applyColumnsToTable(viewOptions._tableToggleInstance);
    }
  };
})();
